package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.ui.svg.forEachRecursive
import web.cssom.ClassName
import web.svg.SVGGraphicsElement
import kotlin.properties.Delegates

data class Point(val id: LogicalBusId, val elements: List<SVGGraphicsElement>) {
    private val tokens = elements.firstOrNull()?.classList
    var probed: Boolean by TrueBooleanClassname(tokens, ClassName("probed"))::value
    var selected: Boolean by TrueBooleanClassname(tokens, ClassName("selected"))::value
    var voltage: ClassName? by VoltageClass(tokens)::value
    var valid: Boolean by FalseBooleanClassname(tokens, ClassName("invalid"))::value
    var available: Boolean by FalseBooleanClassname(tokens, ClassName("out-of-service"))::value

    var noData: Boolean by Delegates.observable(false) { _, _, _ ->
        updateFill()
    }

    var strokeColor: String? by Delegates.observable(null) { _, _, _ ->
        updateStroke()
    }

    var fillColor: String? by Delegates.observable(null) { _, _, _ ->
        updateFill()
    }

    var scale: Double? by Delegates.observable(null) { _, _, _ ->
        updateScale()
    }

    fun updateStroke() {
        val color = this.strokeColor
        if (color != null) {
            elements.forEachRecursive { it.style.setProperty("stroke", color) }
        } else {
            elements.forEachRecursive { it.style.removeProperty("stroke") }
        }
    }

    fun updateFill() {
        if (noData) {
            elements.forEachRecursive {
                it.classList.value = ClassName("node-invalid")
//                it.style.setProperty("fill", "red")
                elements.forEachRecursive { it.style.removeProperty("fill") }
            }
        } else {
            val color = this.fillColor
            if (color != null) {
                elements.forEachRecursive { it.style.setProperty("fill", color) }
            } else {
                elements.forEachRecursive { it.style.removeProperty("fill") }
            }
        }
    }

    fun updateScale() {
        val scale = this.scale
        if (scale != null) {
            elements.forEachRecursive { it.style.setProperty("transform", "scale($scale)") }
            elements.forEachRecursive { it.style.setProperty("transform-box", "fill-box") }
            elements.forEachRecursive { it.style.setProperty("transform-origin", "center") }
        } else {
            elements.forEachRecursive { it.style.removeProperty("transform") }
            elements.forEachRecursive { it.style.removeProperty("transform-box") }
            elements.forEachRecursive { it.style.removeProperty("transform-origin") }
        }
    }
}
